import { render, staticRenderFns } from "./CaseFluidDetails.vue?vue&type=template&id=a6f34ab2&scoped=true&"
import script from "./CaseFluidDetails.vue?vue&type=script&lang=js&"
export * from "./CaseFluidDetails.vue?vue&type=script&lang=js&"
import style0 from "./CaseFluidDetails.vue?vue&type=style&index=0&id=a6f34ab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f34ab2",
  null
  
)

export default component.exports